import { render, staticRenderFns } from "./uploadDocuments.vue?vue&type=template&id=a992beae&scoped=true"
import script from "./uploadDocuments.vue?vue&type=script&lang=js"
export * from "./uploadDocuments.vue?vue&type=script&lang=js"
import style0 from "./uploadDocuments.vue?vue&type=style&index=0&id=a992beae&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a992beae",
  null
  
)

export default component.exports